import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=03683f6d&scoped=true&"
import script from "./CustomerForm.vue?vue&type=script&lang=js&"
export * from "./CustomerForm.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/customer/CustomerForm/CustomerFormStyle.css?vue&type=style&index=0&id=03683f6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03683f6d",
  null
  
)

export default component.exports